import React from 'react';
import {Avatar, Button, Chip, TableCell, TableRow} from "@mui/material";
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import Grid from "@mui/material/Grid2";
import {getRole} from "../../../../utils/roles";
import Constants from "../../../../utils/constants";

function OperateurRow({operateur, onEdit, onDelete, canDelete}) {
    return (
        <TableRow hover onClick={() => onEdit("operateur", operateur.id)} style={{cursor: 'pointer'}}>
            <TableCell>
                <Chip label={getRole(operateur.roles)} className={"chip-role-" + getRole(operateur.roles)}/>
            </TableCell>
            <TableCell component="th">
                {operateur.libelle}
            </TableCell>
            <TableCell className={"tableCell-logo"}>
                <Avatar src={Constants.API_ASSETS_USER_LOGO + operateur.logo?.contentUrl}/>
            </TableCell>
            <TableCell>{operateur.email}</TableCell>
            <TableCell>
                {operateur.laveuse && operateur.laveuse?.description}
            </TableCell>
            <TableCell>
                {operateur.isAccredited
                    ? <Button size="small" disabled className="toggle-button-small button-selected-green">Oui</Button>
                    : <Button size="small" disabled className="toggle-button-small button-selected-red">Non</Button>}
            </TableCell>
            <TableCell>
                <Grid container justify={"flex-end"} spacing={2}>
                    <Grid item>
                        <Button color="secondary" size="small"
                                onClick={(e) => { e.stopPropagation(); onEdit("operateur", operateur.id); }}
                                startIcon={<ModeEditOutlineOutlinedIcon/>}>
                            Editer
                        </Button>
                    </Grid>
                    <Grid item>
                        <Button color="error" size="small"
                                disabled={!canDelete(operateur)}
                                onClick={(e) => { e.stopPropagation(); onDelete(operateur); }}
                                startIcon={<CloseOutlinedIcon/>}>
                            Supprimer
                        </Button>
                    </Grid>
                </Grid>
            </TableCell>
        </TableRow>
    );
}

export default OperateurRow;
